import type { Employer } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

const TRACK_MODAL = appStrings.modules.employer.scoop.track.modal;

export const useAgentContext = (employer: Employer) => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'The Scoop',
    description:
      'Overview section with a summary about the employer and key stats including industry, career track, and company size.',
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'About',
    display: 'Text summary describing the employer',
    data: { about: employer.the_scoop_about },
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Roles',
    display: 'Text summary describing roles at the employer',
    data: { roles: employer.the_scoop_roles },
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Industry',
    display: 'Stat item with briefcase icon',
    data: { industry: employer.industries[0]?.name },
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Track',
    display: 'Stat item with route icon and info modal explaining career tracks',
    detail: Object.values(TRACK_MODAL.body)
      .map((entry) => `${entry.title}: ${entry.description} (e.g. ${entry.examples.join(', ')})`)
      .join('\n'),
    data: {
      minimum_track: employer.minimum_track ? `${employer.minimum_track} or Higher` : undefined,
    },
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: 'Size',
    display: 'Stat item with building icon',
    data: { size: employer.size },
  });
};
